<template>
  <d-container class="layout-default" fluid>
    <d-row>
      <d-col class="layout-side-img d-none d-md-block" cols="3">
        <d-link href="https://www.roosh.online">
          <img src="@/assets/images/ROOSH-logo.png" alt="ROOSH." class="layout-logo">
        </d-link>
      </d-col>

      <d-col class="main-content p-0 col-12 col-md-9" tag="main">
        <navbar />

        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Navbar from '@/components/common/Navbar';

export default {
  name: 'layout-default',
  components: { Navbar },
};
</script>
